module.exports = __webpack_public_path__ + "static/vmware_9.672ce8b7.jpg";